import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { cardinalApi, guard } from '../services/auth.api'
import { Code, CodeFilters } from '@icure/cardinal-sdk'
import { loadFromIterator, tagsByIds } from './utils'

export const codeApiRtk = createApi({
  reducerPath: 'codeApi',
  tagTypes: ['Code'],
  baseQuery: fetchBaseQuery({
    baseUrl: '',
  }),
  endpoints: (builder) => ({
    getCodes: builder.query<Code[] | undefined, string>({
      async queryFn(type, { getState }) {
        const codeApi = (await cardinalApi(getState))?.code
        return guard([codeApi], async ([codeApi]): Promise<Code[]> => {
          return await loadFromIterator(await codeApi.filterCodesBy(CodeFilters.byRegionTypeCodeVersion('be', { type })), 1000)
        })
      },
      providesTags: tagsByIds('Code', 'all'),
    }),
    createOrUpdateCodes: builder.mutation<Code[] | undefined, Code[]>({
      async queryFn(codes, { getState }) {
        const codeApi = (await cardinalApi(getState))?.code
        return guard([codeApi], async ([codeApi]): Promise<Code[]> => {
          return await codeApi.createCodes(codes.map((code) => new Code({ ...code, regions: ['be'] })))
        })
      },
      invalidatesTags: (result) => (result ?? []).map((code) => ({ type: 'Code', id: code.id })).concat({ type: 'Code', id: 'all' }) as { type: 'Code'; id: string }[],
    }),
  }),
})

export const { useGetCodesQuery, useCreateOrUpdateCodesMutation } = codeApiRtk
